<script setup>
import { url } from '@/config/urls';
import router from '@/router/index.js';
const props = defineProps({
  returnSearchPageUrl: {
    type: String,
    default: url.page.returnSearch
  }
});

const goToReturnSearch = () => {
  router.push(props.returnSearchPageUrl);
}

</script>

<template>
  <div class="modal com_modal2 fade" id="returnCompleteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_c_check1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0">返品依頼の送信が完了しました</h3>
          <p class="com_fs12 com_center1 com_color3 com_mgb0">※返品をお受けできない商品もございます。ご了承くださいませ。</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1 wd1" @click="goToReturnSearch">返品依頼TOP</button>
        </div>
      </div>
    </div>
  </div>
</template>
